import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-new-target-modal',
  templateUrl: './new-target-modal.component.html',
  styleUrls: ['./new-target-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewTargetModalComponent implements AfterViewInit {

  ngAfterViewInit(): void {

  }

}
